import { render } from "./index.vue?vue&type=template&id=54f7fcf4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=54f7fcf4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-54f7fcf4"

export default script